import {
  type EmailVariableRecipient,
  interpolateEmailWithVariableMap,
} from './email-variables';

export type EmailComposePayload = {
  mode?: 'existing' | 'draft';
  subject?: string;
  body?: string;
  bodyHtml?: string;
  conversationId?: string;
};

export type MissiveResponseVariables = EmailVariableRecipient;

export function buildEmailGreeting(recipientName?: string) {
  const trimmed = recipientName?.trim();

  if (!trimmed) {
    return 'Dear Client,';
  }

  return `Dear ${trimmed},`;
}

export function getRecipientFirstName(recipientName?: string) {
  return recipientName?.trim().split(/\s+/)[0] || '';
}

export function htmlToPlainText(html: string) {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function plainTextToHtml(text: string) {
  return text
    .split(/\n\n+/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`)
    .join('');
}

export function interpolateMissiveResponseHtml(
  html: string,
  variables: MissiveResponseVariables,
) {
  return interpolateEmailWithVariableMap(html, null, variables);
}

export function buildEmailBodyPreview(
  bodyHtml: string,
  variables: MissiveResponseVariables,
) {
  return htmlToPlainText(interpolateMissiveResponseHtml(bodyHtml, variables));
}

export function resolveEmailDraftBody(
  plainBody: string,
  bodyHtml?: string,
  bodyEdited?: boolean,
) {
  const trimmed = plainBody.trim();

  if (!trimmed) {
    return '';
  }

  if (bodyHtml && !bodyEdited) {
    return bodyHtml;
  }

  return plainTextToHtml(trimmed);
}

export function buildEmailFromTemplate(
  templateContent: string,
  recipientName?: string,
) {
  return `${buildEmailGreeting(recipientName)}\n\n${templateContent.trim()}`;
}
